import { useSelector } from "react-redux";
import store from "../storeWire";
import {
    fetchOrderList,
    fetchPlaceOrderItems,
    fetchExportOrderCount,
    fetchManufacturerList,
    getValidateOrderFromServer,
    getOrderItemList,
    fetchOrderDetail
} from "../store/slice/model/Order";
import { remove_all_selected_fields, 
        toggle_single_selected_fields,
        remove_single_selected_fields } from "src/store/slice/model/Order/OrderHistoryUI";
import OrderRepository from "src/repository/OrderRepository";

export function useOrderStore() {
    const order_list = useSelector((state) => state.entities.model_Order.orderList)
    const validate_order_from_server = useSelector((state) => state.entities.model_Order.validateOrderFromServer)
    const place_order_item_list = useSelector((state) => state.entities.model_Order.placeOrderItemList)
    const order_export_count = useSelector((state) => state.entities.model_Order.orderExportCount)
    const order_manufacturer_list = useSelector((state) => state.entities.model_Order.orderManuFactureList)
    const placeOrderLoading = useSelector((state) => state.entities.model_Order.placeOrderLoading);
    const orderParams = useSelector((state) => state.entities.model_Order.orderParams);
    const expand_list = useSelector((state) => state.entities.model_OrderHistory__UI.expandArray);
    const order_item_list = useSelector((state) => state.entities.model_Order.orderItemList)
    const order_detail = useSelector((state) => state.entities.model_Order.orderDetail)
    const selected_fields = useSelector((state) => state.entities.model_OrderHistory__UI.selected_fields)

    let data = {
        order_list,
        place_order_item_list,
        order_export_count,
        order_manufacturer_list,
        placeOrderLoading,
        orderParams,
        expand_list,
        validate_order_from_server, 
        order_item_list,
        order_detail,
        selected_fields
    };
    let fetch = {
        fetch_order_list: async (params) => {
            return await store.dispatch(fetchOrderList(params))
        },
        send_email_sales_representative_order: async (params) => {
            return await new OrderRepository().sendEmailSalesRepresentativeOrder(params.lineItemNumber, params.purchaseOrderNumber, params.orderNumber)
        },
        send_Order_Item_Email: async (params) => {
            return await new OrderRepository().sendOrderItemEmail(params)
        },
        fetch_place_order_items: async (orderId) => {
            return await store.dispatch(fetchPlaceOrderItems(orderId))
        },
        fetch_order_export_count: async() => {
            return await store.dispatch(fetchExportOrderCount())
        },
        fetch_manuFacturer_list: async () => {
            return await store.dispatch(fetchManufacturerList())
        },
        send_order_po_item_email: async(params) => {
            return await new OrderRepository().sendOrderPOLineItemEmail(params)
        },
        get_validate_order_from_server: async(params) => {
            return await store.dispatch(getValidateOrderFromServer(params))
            // return await new OrderRepository().getValidateOrderFromServer(params)
        },
        get_order_item_list: async (params) => {
            return await store.dispatch(getOrderItemList(params))
        },
        billing_currency_conversion: async(params) => {
            return await new OrderRepository().billingCurrencyConversion(params)
        },
        fetch_order_detail: async(params) => {
            return await store.dispatch(fetchOrderDetail(params))
        },
    };
    let set = {
        place_your_order: async (params) => {
            return await new OrderRepository().placeYourOrder(params)
        },
        order_download_invoice: async (params) => {
            return await new OrderRepository().orderDownloadInvoice(params);
        },
        export_order: async (params) => {
            return await new OrderRepository().exportOrder(params);
        },
        export_email: async (params) => {
            return await new OrderRepository().exportEmail(params);
        },
        export_email_sales: async (params) => {
            return await new OrderRepository().exportEmailSales(params);
        },
        order_cancellation_email: async (params) => {
            return await new OrderRepository().orderCancellationEmail(params);
        },
        toggle_single_selected_fields: async (params) => {
            return await store.dispatch(toggle_single_selected_fields(params))
        },
        remove_all_selected_fields: async () => {
            return await store.dispatch(remove_all_selected_fields())
        },
        remove_single_selected_fields: async (params) => {
            return await store.dispatch(remove_single_selected_fields(params))
        }
    };
    return [data, fetch, set]
}